import React, { useState, createContext } from 'react'

export const CompareContext = createContext()

/** @type {import("./compareProvider").default} */
export const CompareProvider = ({ data: fetchedData, children }) => {
  const [data, setData] = useState(fetchedData || {})

  const {
    listings = [],
    features = [],
    integrations = [],
    alternatives = [],
    description = null,
    comparisonReviews = [],
    title = '',
    gaLabel = listings.length > 1 ? 'ua_compare' : 'ua_compare_single',
  } = data

  return (
    <CompareContext.Provider
      value={{
        listings,
        features,
        integrations: integrations.sort(),
        alternatives,
        description,
        comparisonReviews,
        title,
        gaLabel,
        setData,
      }}
    >
      {children}
    </CompareContext.Provider>
  )
}
